export default function productLoop () {
  const $ = jQuery;
  const $moreColorsLink = $( 'ul.products .more-colors-link' );
  const $variableItem   = $( 'li.product .variable-item' );

  $variableItem.click( function( e ) {
    // Change single variation name text e.g. "Trout green"
    let $singleVariationName = $( this ).closest( 'li.product' ).find( '.single-variation-name' );
    $singleVariationName.html( $( this ).attr( 'title' ) );
  });

}
